import { typedEnv } from '@app/environment/typed-env';
import { DesignOutDto, LibraryOutDto } from '@app/swagger-types';
import { DesignFormSchema } from '../template/api/template.form.schema.api';
import { QRCodeFormSchema } from './api/qr-code.form.schema.api';

export const getDeviceId = () => {
  return localStorage.getItem('deviceId');
};

export const setDeviceId = (id: string) => {
  localStorage.setItem('deviceId', id);
};

export const getLinkForCode = (id: string) => {
  return `${typedEnv.REACT_APP_HOST_URL}/qr/${id}`;
};

export const getLinkForQrCodeTemplate = (id: string) => {
  return `${typedEnv.REACT_APP_HOST_URL}/templates/${id}/edit`;
};

export const extractStylePropsFromQRForm = (form: QRCodeFormSchema, template?: DesignOutDto) => {
  const { patternColor, cornerColor, patternType, cornerType, libraryId, templateId } = form;
  const qrProps =
    templateId && template
      ? {
          backgroundColor: template.backgroundColor,
        }
      : {
          backgroundColor: form.backgroundColor,
        };
  const frameProps: Partial<DesignOutDto> =
    templateId && template
      ? {
          frameType: template.frameType,
          frameText: template.frameText,
          frameTextSize: template.frameTextSize,
          frameTextColor: template.frameTextColor,
          frameBackgroundColor: template.frameBackgroundColor,
        }
      : {
          frameType: form.frameType,
          frameText: form.frameText || undefined,
          frameTextSize: form.frameTextSize,
          frameTextColor: form.frameTextColor,
          frameBackgroundColor: form.frameBackgroundColor,
        };
  return { ...qrProps, patternColor, cornerColor, patternType, cornerType, libraryId, ...frameProps };
};

export const extractStylePropsFromQRTemplateForm = (form: DesignFormSchema): Partial<DesignFormSchema> => {
  const {
    backgroundColor,
    patternColor,
    cornerColor,
    patternType,
    cornerType,
    libraryId,
    frameType,
    frameText,
    frameTextSize,
    frameTextColor,
    frameBackgroundColor,
  } = form;
  return {
    backgroundColor,
    patternColor,
    cornerColor,
    patternType,
    cornerType,
    libraryId,
    frameType,
    frameText,
    frameTextSize,
    frameTextColor,
    frameBackgroundColor,
  };
};

export const extractStylePropsFromQRDesign = (
  design?: Omit<DesignOutDto, 'createdBy' | 'template' | 'library'> & {
    library?: LibraryOutDto | null;
  }
) => {
  if (!design) {
    return {};
  }
  const {
    backgroundColor,
    patternColor,
    cornerColor,
    patternType,
    cornerType,
    frameType,
    frameText,
    frameTextSize,
    frameTextColor,
    frameBackgroundColor,
  } = design;
  const libraryId = design.library?.id;
  return {
    backgroundColor,
    patternColor,
    cornerColor,
    patternType,
    cornerType,
    libraryId,
    frameType,
    frameText,
    frameTextSize,
    frameTextColor,
    frameBackgroundColor,
  };
};
